import { render, staticRenderFns } from "./TabsHome.vue?vue&type=template&id=9f5eb55c&scoped=true"
import script from "./TabsHome.vue?vue&type=script&lang=js"
export * from "./TabsHome.vue?vue&type=script&lang=js"
import style0 from "./TabsHome.vue?vue&type=style&index=0&id=9f5eb55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5eb55c",
  null
  
)

export default component.exports